import { ADMIN_BASE_URL, WEBSOCKET_URL } from "../../../../../utils/properties";

//Admin Chat
const chatProperties = {
    baseUrl: ADMIN_BASE_URL,
    websocketUrl: WEBSOCKET_URL,
    type: 'Admin'
}

//Agent Chat
// const chatProperties = {
//     baseUrl: 'https://api.pre-prod.ozonetel.com/CAServicesV3/mdlConnection.php',
//     websocketUrl: '',
//     type: 'Agent'
// }
export default chatProperties;
